import { render, staticRenderFns } from "./pageConfig.vue?vue&type=template&id=1b53c9b8&scoped=true"
import script from "./pageConfig.vue?vue&type=script&lang=js"
export * from "./pageConfig.vue?vue&type=script&lang=js"
import style0 from "./pageConfig.vue?vue&type=style&index=0&id=1b53c9b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53c9b8",
  null
  
)

export default component.exports